import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CopilotService {

  constructor(private http: HttpClient) {}


  generateEventViaAI(prompt: string): Observable<any> {
    return this.http.post(environment.HOST.HIRE_GENAI_URL + '/events/generate', { prompt });
  }

  generateJob(prompt: string): Observable<any> {
    return this.http.post(environment.HOST.HIRE_GENAI_URL + '/jobs/generate', { prompt });
  }

  submitEvent(eventData: any): Observable<any> {
    return this.http.post<any>(environment.HOST.FAST_API_URL + '/events', eventData);
  }

  submitJob(jobData: any): Observable<any> {
    return this.http.post(environment.HOST.FAST_API_URL + '/job-roles', jobData);
  }

  private stripHtmlTags(text: string): string {
    if (!text) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  formatJobPayload(apiResponse: any): any {
    let locations = Array.isArray(apiResponse.locations) ? apiResponse.locations : [];
    
    if (locations.length === 0) {
      locations = [{
        country: '',
        state: '',
        city: '',
        business_unit: 'Demo Unit',
        opening: 1,
        max_applicant: 10,
        diversity_male: 0,
        diversity_female: 0,
        diversity_other: 0
      }];
    }
    
    return {
      name: apiResponse.name,
      role_type_id: apiResponse.role_type_id,
      requirement: "",
      description: this.stripHtmlTags(apiResponse.description), // Strip HTML tags to prevent 400 errors
      attachment: apiResponse.attachment || null,
      work_mode: apiResponse.work_mode,
      locations: locations.map((location: any) => {
        let cityArray = [];
        if (location.city) {
          if (Array.isArray(location.city)) {
            cityArray = location.city;
          } else if (typeof location.city === 'string') {
            cityArray = [location.city];
          }
        }
        
        return {
          country: location.country || '',
          state: location.state || '',
          city: cityArray,
          business_unit: location.business_unit || "Demo Unit",
          opening: location.opening || 1,
          max_applicant: location.max_applicant || 10,
          diversity_male: location.diversity_male || 0,
          diversity_female: location.diversity_female || 0,
          diversity_other: location.diversity_other || 0
        };
      })
    };
  }

  formatEventPayload(apiResponse: any): any {
    let institutes = [];
    if (apiResponse.institutes && Array.isArray(apiResponse.institutes)) {
      institutes = apiResponse.institutes.map((inst: any) => 
        typeof inst === 'object' ? inst.id : inst
      );
    }

    return {
      name: apiResponse.name,
      event_start_date: apiResponse.event_start_date,
      event_end_date: apiResponse.event_end_date,
      job_roles: apiResponse.job_roles.map((role: any) => 
        typeof role === 'object' ? role.id : role
      ),
      work_experience: apiResponse.work_experience,
      min_salary: apiResponse.min_salary,
      max_salary: apiResponse.max_salary,
      event_category_id: typeof apiResponse.event_category_id === 'object' 
        ? apiResponse.event_category_id.id 
        : apiResponse.event_category_id,
      event_type_id: typeof apiResponse.event_type_id === 'object'
        ? apiResponse.event_type_id.id
        : apiResponse.event_type_id,
      registration_start_date: apiResponse.registration_start_date,
      registration_end_date: apiResponse.registration_end_date,
      form_uuid: typeof apiResponse.form_uuid === 'object'
        ? apiResponse.form_uuid.uuid
        : apiResponse.form_uuid,
      email_template_id: typeof apiResponse.email_template_id === 'object'
        ? apiResponse.email_template_id.id
        : apiResponse.email_template_id,
      institutes: institutes,
      institution_address: apiResponse.institution_address || null
    };
  }

  getRoleTypeName(roleTypeId: number): string {
    const roleTypes: {[key: number]: string} = {
      1: 'Full-time',
      2: 'Part-time',
      3: 'Contract',
      4: 'Internship',
      5: 'Temporary'
    };
    
    return roleTypes[roleTypeId] || `Type ${roleTypeId}`;
  }

  getLocationDetails(location: any): string {
    if (Array.isArray(location.city)) {
      return `${location.city.join(', ')}, ${location.state}, ${location.country}`;
    }
    return `${location.city}, ${location.state}, ${location.country}`;
  }

  getEventFormData(): Observable<any> {
    return this.http.get(environment.HOST.FAST_API_URL + '/events/form-data', { 
      observe: 'response' 
    });
  }

  getRoleTypes(): Observable<any> {
    return this.http.get(environment.HOST.FAST_API_URL + '/job-roles/form-data', { 
      observe: 'response' 
    });
  }
}

